import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'dashboard',
  data: function data() {
    return {
      bianlidianCards: [{
        label: '销售分析',
        icon: 'el-icon el-icon-s-data',
        name: 'BairunBianlidianSaleAnalyse',
        color: '#5cdbd3'
      }, {
        label: '实时库存',
        icon: 'el-icon el-icon-s-data',
        name: 'BairunBianlidianStockAnalyse',
        color: '#5cdbd3'
      }, {
        label: '月度目标',
        icon: 'el-icon el-icon-s-data',
        name: 'BairunBianlidianTargetAnalyse',
        color: '#5cdbd3'
      }, {
        label: '利润分析',
        icon: 'el-icon el-icon-s-data',
        name: 'BairunBianlidianLirunAnalyse',
        color: '#5cdbd3'
      }]
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo'])),
  methods: {
    toTarget: function toTarget(name) {
      this.$router.push({
        name: name
      });
    }
  }
};